import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = ["alt", "src"];
const _hoisted_2 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#374151",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const _hoisted_3 = {
  class: "schedule-pill"
};
const _hoisted_4 = {
  class: "topbar-search"
};
const _hoisted_5 = {
  class: "topbar-search"
};
const _hoisted_6 = {
  class: "topbar-user"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_b_navbar_brand = _resolveComponent("b-navbar-brand");
  const _component_b_navbar_toggle = _resolveComponent("b-navbar-toggle");
  const _component_b_nav_item = _resolveComponent("b-nav-item");
  const _component_contact_modal = _resolveComponent("contact-modal");
  const _component_b_icon_camera_video_fill = _resolveComponent("b-icon-camera-video-fill");
  const _component_b_navbar_nav = _resolveComponent("b-navbar-nav");
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_nav_form = _resolveComponent("b-nav-form");
  const _component_search_modal = _resolveComponent("search-modal");
  const _component_Login = _resolveComponent("Login");
  const _component_b_icon_person = _resolveComponent("b-icon-person");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_b_nav_item_dropdown = _resolveComponent("b-nav-item-dropdown");
  const _component_b_collapse = _resolveComponent("b-collapse");
  const _component_b_navbar = _resolveComponent("b-navbar");
  return $data.networkInfo ? (_openBlock(), _createBlock(_component_b_navbar, {
    key: 0,
    class: "sbn-navbar",
    toggleable: "lg",
    type: "light"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_navbar_brand, {
      to: "/",
      class: "sbn-navbar-brand"
    }, {
      default: _withCtx(() => [_createVNode(_component_router_link, {
        to: "/",
        class: "brand-link"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(["brand-mark", {
            'has-image': !!$options.brandImage
          }])
        }, [$options.brandImage ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "brand-logo-fill",
          alt: $data.networkInfo.name,
          src: $options.brandImage
        }, null, 8, _hoisted_1)) : (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[4] || (_cache[4] = [_createElementVNode("polygon", {
          points: "23 7 16 12 23 17 23 7"
        }, null, -1), _createElementVNode("rect", {
          x: "1",
          y: "5",
          width: "15",
          height: "14",
          rx: "2",
          ry: "2"
        }, null, -1)]))]))], 2)], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    }), _createVNode(_component_b_navbar_toggle, {
      target: "nav-collapse",
      class: "sbn-toggle"
    }), _createVNode(_component_b_collapse, {
      id: "nav-collapse",
      "is-nav": ""
    }, {
      default: _withCtx(() => [_createVNode(_component_b_navbar_nav, {
        class: "sbn-main-nav"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_nav_item, {
          to: "/faq/"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("FAQ", -1)]))], undefined, true),
          _: 1
        }), _createVNode(_component_b_nav_item, {
          to: "/about/"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("About Us", -1)]))], undefined, true),
          _: 1
        }), _createVNode(_component_contact_modal, {
          class: "nav-inline-link"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("Contact Us", -1)]))], undefined, true),
          _: 1
        }), $options.isLoggedIn ? (_openBlock(), _createBlock(_component_b_nav_item, {
          key: 0,
          to: "/live/",
          class: "schedule-link"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_b_icon_camera_video_fill), _cache[8] || (_cache[8] = _createTextVNode(" Schedule ", -1))])], undefined, true),
          _: 1
        })) : _createCommentVNode("", true)], undefined, true),
        _: 1
      }), _createVNode(_component_b_navbar_nav, {
        class: "ms-auto sbn-right-nav"
      }, {
        default: _withCtx(() => [!$options.isLoggedIn ? (_openBlock(), _createBlock(_component_b_nav_form, {
          key: 0,
          onSubmit: _withModifiers($options.openSearchModal, ["prevent"]),
          class: "topbar-search-wrap"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_cache[9] || (_cache[9] = _createElementVNode("span", {
            class: "search-icon"
          }, [_createElementVNode("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [_createElementVNode("circle", {
            cx: "11",
            cy: "11",
            r: "8"
          }), _createElementVNode("line", {
            x1: "21",
            y1: "21",
            x2: "16.65",
            y2: "16.65"
          })])], -1)), _createVNode(_component_b_form_input, {
            size: "sm",
            placeholder: "Search Network",
            name: "text_search",
            modelValue: $data.searchText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.searchText = $event),
            class: "topbar-search-input"
          }, null, 8, ["modelValue"])])], undefined, true),
          _: 1
        }, 8, ["onSubmit"])) : _createCommentVNode("", true), !$options.isLoggedIn ? (_openBlock(), _createBlock(_component_search_modal, {
          key: 1,
          ref: "searchModal"
        }, null, 512)) : _createCommentVNode("", true), !$options.isLoggedIn ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createVNode(_component_Login, {
          show: $data.showLoginModal,
          onClose: _cache[1] || (_cache[1] = $event => $data.showLoginModal = false)
        }, null, 8, ["show"]), _createElementVNode("button", {
          class: "btn-login-top",
          onClick: _cache[2] || (_cache[2] = $event => $data.showLoginModal = true)
        }, " Log In "), _createVNode(_component_router_link, {
          to: "/subscribe/",
          class: "btn-subscribe-top"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Subscribe ", -1)]))], undefined, true),
          _: 1
        })], 64)) : _createCommentVNode("", true), $options.isLoggedIn ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 3
        }, [_createVNode(_component_b_nav_form, {
          action: "/video",
          method: "GET",
          onSubmit: $options.searchVideos,
          class: "topbar-search-wrap logged-search"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[11] || (_cache[11] = _createElementVNode("span", {
            class: "search-icon"
          }, [_createElementVNode("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [_createElementVNode("circle", {
            cx: "11",
            cy: "11",
            r: "8"
          }), _createElementVNode("line", {
            x1: "21",
            y1: "21",
            x2: "16.65",
            y2: "16.65"
          })])], -1)), _createVNode(_component_b_form_input, {
            size: "sm",
            placeholder: "Search Network",
            name: "text_search",
            modelValue: $data.searchText,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.searchText = $event),
            class: "topbar-search-input"
          }, null, 8, ["modelValue"])])], undefined, true),
          _: 1
        }, 8, ["onSubmit"]), _createVNode(_component_router_link, {
          to: "/account/subscription",
          class: "btn-subscribe-top ms-2"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" My Subscription ", -1)]))], undefined, true),
          _: 1
        }), _createVNode(_component_b_nav_item_dropdown, {
          placement: "bottom-end",
          class: "user-dropdown"
        }, {
          "button-content": _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_b_icon_person), _createElementVNode("em", null, _toDisplayString($data.userInfo.username), 1)])]),
          default: _withCtx(() => [_createVNode(_component_b_dropdown_item, {
            to: "/account"
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("Profile", -1)]))], undefined, true),
            _: 1
          }), _createVNode(_component_b_dropdown_item, {
            to: "/account/subscription"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("Subscription", -1)]))], undefined, true),
            _: 1
          }), _createVNode(_component_b_dropdown_item, {
            to: "/account/billing"
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("Billing", -1)]))], undefined, true),
            _: 1
          }), _createVNode(_component_b_dropdown_item, {
            href: "#",
            onClick: _withModifiers($options.logout, ["prevent"])
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("Sign Out", -1)]))], undefined, true),
            _: 1
          }, 8, ["onClick"])], undefined, true),
          _: 1
        })], 64)) : _createCommentVNode("", true)], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true);
}